module.exports = __webpack_public_path__ + "static/premium-classic@2x-42d7b20be579b1f393b4a39bb82d9bb1.webp";